import { Modal } from "@materialstyle/materialstyle";
import { dbService } from "../dbService";
import transliterateFromKannada from "./transliteration/transliterateFromKannada";

export const visheshaDates = {
  dates: [],
  shown: false,
  modal: null,
  loading: false,

  init() {
    if (this.modal !== null) return;

    let modalEl = document.getElementById("visheshaDatesModal");
    this.modal = new Modal(modalEl);
    Alpine.effect(async () => {
      let shown = this.shown;
      let lang = Alpine.store("userPreferences").uiLanguage;
      if (this.shown) {
        await this._computeVisheshaDates();
      }
    });
  },

  async _computeVisheshaDates() {
    this.loading = true;
    // 1. Safe fetching with fallback
    const visheshaDates =
      (await dbService.getDocumentsWithVishesha("parva_vishesha")) || [];

    if (visheshaDates.length > 0) {
      const userPrefs = Alpine.store("userPreferences");
      const panchangam = Alpine.store("panchangam");

      const transliterate = new transliterateFromKannada(userPrefs?.uiLanguage);
      // 2. Check for English preference AND that panchangam store exists
      this.dates = transliterate.transliterateObject(visheshaDates);
    } else {
      this.dates = []; // 3. Explicitly clear if no dates found
    }
    this.loading = false;
  },

  async showVisehshaDates() {
    if (this.loading) return;
    if (this.dates.length > 0) {
      this.modal.show();
      return;
    }

    this.shown = true;
    this.modal.show();
    await this._computeVisheshaDates();

    this.scrollToToday();
  },

  // Add this inside your visheshaDates object
  async scrollToToday() {
    await Alpine.nextTick(); // Wait for Alpine to finish rendering the list

    const today = new Date().toISOString().split("T")[0]; // "2026-01-21"

    // Find the index of the first date that is today or in the future
    const index = this.dates.findIndex((item) => item.date >= today);

    if (index !== -1) {
      // Select the specific list item using its index
      const element = document.querySelector(
        `#visheshaDatesModal .list-group-item:nth-child(${index + 1})`,
      );
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  },
};
